import { language } from "@chef/constants";

export const intl = (
  {
    no: {
      SPECIAL_GOODS: "Dagligvarer og tillegg",
      LINK_TEXT_CHANGE_ADDONS: "Velg dagligvarer",
      BUY_SPECIAL_GOODS: "Kjøp frokost?",
      PIECES: "stk",
      STANDALONE_GOODS: "Dagligvarer",
      SPECIAL_GOODS_DESCRIPTION:
        "Bestill dagligvarer sammen med din matkasse. Legg til melk fra Røros, Lisas nyrørte syltetøy eller nydelig spekeskinke fra Pers.",
    },
    se: {
      SPECIAL_GOODS: "Linas Matbutik",
      LINK_TEXT_CHANGE_ADDONS: "Visa butiken",
      BUY_SPECIAL_GOODS: "Frukost, lunch och mellanmål",
      PIECES: "st",
      STANDALONE_GOODS: "Livsmedel",
      SPECIAL_GOODS_DESCRIPTION:
        "Komplettera din leverans med livsmedel. I Linas Matbutik hittar du allt du behöver för en god frukost, ett snabbt mellanmål och en smakrik lunchlåda.",
    },
    dk: {
      SPECIAL_GOODS: "Specialvarer og tillæg",
      LINK_TEXT_CHANGE_ADDONS: "Vælg specialvarer",
      BUY_SPECIAL_GOODS: "Specialvarer",
      PIECES: "stk",
      STANDALONE_GOODS: "Specialvarer",
      SPECIAL_GOODS_DESCRIPTION:
        "Blandt vores specialvarer finder du frisk frugt og grøntsager, brød, samt et stort udvalg af vin for enhver smag.",
    },
  } as const
)[language];
